/**
 * List/table cosmetics for English TMS status strings (Qargo, live badges).
 * Control Centre Palletways KPI cards do **not** use this — they read
 * orders_daily status_bucket from zeecore. Do not map Palletways StatusCodes here.
 */

export type OrderStatusBucket = 'completed' | 'in_progress' | 'pending' | 'cancelled';

export function classifyOrderStatus(status: string | null | undefined): OrderStatusBucket {
  const s = String(status || '').trim().toUpperCase();
  if (!s) return 'pending';

  if (s.includes('CANCEL')) return 'cancelled';

  if (
    s.includes('COMPLETE') ||
    s === 'DELIVERED' ||
    s === 'FINISHED' ||
    s === 'DONE' ||
    s === 'POD' ||
    s === 'DONT_INVOICE' ||
    s === 'INVOICE_POSTED' ||
    s === 'INVOICE_READY'
  ) {
    return 'completed';
  }

  // Explicitly in motion (Qargo / richer TMS)
  if (s.includes('PROGRESS') || s === 'IN_TRANSIT' || s.includes('TRANSIT')) {
    return 'in_progress';
  }

  // Palletways cons_entered + booked/open TMS states → pending bucket (rolls into Active KPI)
  // Same Day TMS jobs ingest as "declared" until GPS confirms collection + delivery
  if (
    s === 'ENTERED' ||
    s === 'PENDING' ||
    s === 'ACTIVE' ||
    s === 'DECLARED' ||
    s.includes('PLAN') ||
    s === 'SCHEDULED' ||
    s === 'SAME_DAY' ||
    s === 'SAME DAY'
  ) {
    return 'pending';
  }

  // Unknown non-terminal statuses stay in the open pipeline (not completed)
  return 'pending';
}

export function isCompletedOrderStatus(status: string | null | undefined): boolean {
  return classifyOrderStatus(status) === 'completed';
}

export function isActiveOrderStatus(status: string | null | undefined): boolean {
  const bucket = classifyOrderStatus(status);
  return bucket === 'pending' || bucket === 'in_progress';
}

export function isCancelledOrderStatus(status: string | null | undefined): boolean {
  return classifyOrderStatus(status) === 'cancelled';
}
